import React from 'react';
import { useTranslation } from 'react-i18next';
import { PropTypes } from 'prop-types';
import { Table } from 'semantic-ui-react';
import { Flex, Segment } from 'nallian-shared-ui/lib/components';
import { useAppsFeaturesRolesFromAssignedRoles } from '../../../hooks/useAppsFeaturesRolesFromAssignedRoles';
import { ASSIGNED_ROLES_TYPES } from '../../../constants';

const PrincipalRoles = ({ principal }) => {
  const { t } = useTranslation();

  const data = useAppsFeaturesRolesFromAssignedRoles(principal?.assignedRoles);

  return (
    <Flex fluid direction="column">
      {data.map(communityApp => (
        <Segment
          secondary
          key={`${communityApp.communityTag}_${communityApp.appTag}`}
          margin="0 0 1rem 0"
        >
          <Table basic="very">
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell width={6}>
                  {communityApp.appName} ({communityApp.communityName})
                </Table.HeaderCell>
                <Table.HeaderCell width={10} />
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {(communityApp.features || []).map(feature => (
                <Table.Row
                  key={`${communityApp.communityTag}_${communityApp.appTag}_${feature.featureTag}`}
                >
                  <Table.Cell width={6}>{feature.featureName}</Table.Cell>
                  <Table.Cell width={10}>
                    {(feature.roles || [])
                      .map(role => {
                        const userGroupSources = role.sources?.filter(
                          s => s.type === ASSIGNED_ROLES_TYPES.USER_GROUP
                        );
                        const userGroupsText = userGroupSources?.length
                          ? ` (${t('userGroups')}: ${userGroupSources.map(s => s.name).join(', ')})`
                          : '';
                        return `${role.roleName}${userGroupsText}`;
                      })
                      .join(', ')}
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </Segment>
      ))}
      {data?.length <= 0 && (
        <Table basic="very">
          <Table.Row>
            <Table.HeaderCell width={6}>{t('noRolesFound')}</Table.HeaderCell>
          </Table.Row>
        </Table>
      )}
    </Flex>
  );
};

PrincipalRoles.propTypes = { principal: PropTypes.object };
PrincipalRoles.defaultProps = { principal: {} };

export default PrincipalRoles;
